<template>
  <div>
    <DialogRoot v-model:open="open">
      <DialogPortal>
        <DialogContent class="modal-content">
          <VisuallyHidden>
            <DialogTitle as="p"></DialogTitle>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
          <div class="flex flex-col h-full">
            <div class="absolute z-20 top-2 right-2 text-white" @click="open = false">
              <button class="flex items-center gap-2 px-2 py-1 bg-black/60 rounded-md opacity-80 transition-all duration-300 md:hover:opacity-100">
                <span class="text-sm text-white">{{ $t('shared.close') }}</span>
              </button>
            </div>
            <div class="flex-1 overflow-y-auto no-scrollbar relative z-10">
              <slot />
            </div>
          </div>
        </DialogContent>
        <DialogOverlay class="modal-overlay" />
      </DialogPortal>
    </DialogRoot>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const router = useRouter()

// Set open state for modal
const open = ref(false)

// Open modal on mounted
onMounted(() => {
  open.value = !!route.query?.restId
})

// Watch query updates to toggle open value
watch(() => route.query, () => {
  open.value = !!route.query?.restId
})

// Watch close event to reset query params
watch(() => open.value, () => {
  if (!open.value) {
    router.push({ query: { ...route.query, restId: undefined, mealId: undefined }})
  }
})
</script>

<style lang="scss" scoped>
.modal-content {
  @apply fixed z-[90];
  @apply flex flex-col bg-white;
  @apply inset-0 overflow-hidden;

  @screen sm {
    @apply w-4/5 max-w-2xl top-12 left-1/2 bottom-0;
    @apply -translate-x-1/2 h-auto rounded-t-2xl;
  }
}

.modal-overlay {
  @apply fixed z-40 inset-0 bg-black/40 backdrop-blur-md;
}

@keyframes fadeInModal {
  from {
    @apply opacity-0 mt-16;
  }
  to {
    @apply opacity-100;
  }
}

@keyframes fadeOutModal {
  from {
    @apply opacity-100;
  }
  to {
    @apply opacity-0 mt-16;
  }
}

.modal-content[data-state="open"] {
  animation: fadeInModal 300ms ease-out;
}

.modal-content[data-state="closed"] {
  animation: fadeOutModal 200ms ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.modal-overlay[data-state="open"] {
  animation: fadeIn 300ms ease-out;
}

.modal-overlay[data-state="closed"] {
  animation: fadeOut 200ms ease-in;
}
</style>